import { simplePath } from 'ze-api-contract/utils';

export interface NavigationItem {
  id: string;
  name: string;
  isPinned: boolean;
}

export const NAVIGATION_QUERY_KEY_FIRST_ITEM = 'navigation-breadcrumbs';

export const GET_ORG_NAVIGATION_ITEMS = 'v2/user-navigation/org-items';
export const GET_PROJ_NAVIGATION_ITEMS = 'v2/user-navigation/:organization/proj-items';
export const GET_APP_NAVIGATION_ITEMS = 'v2/user-navigation/:organization/:project/app-items';

export const get_org_navigation_items = () => simplePath(GET_ORG_NAVIGATION_ITEMS, {});
export const get_proj_navigation_items = (params: { organization: string }) =>
  simplePath(GET_PROJ_NAVIGATION_ITEMS, params);
export const get_app_navigation_items = (params: { organization: string; project: string }) =>
  simplePath(GET_APP_NAVIGATION_ITEMS, params);

export type NavigationItemsType = 'organization' | 'project' | 'application';

export const POST_PIN_NAVIGATION_ITEM = 'v2/user-navigation/pin';
export const POST_UNPIN_NAVIGATION_ITEM = 'v2/user-navigation/unpin';

export const post_pin_navigation_item = () => simplePath(POST_PIN_NAVIGATION_ITEM, {});
export const post_unpin_navigation_item = () => simplePath(POST_UNPIN_NAVIGATION_ITEM, {});

export interface PinNavigationBody {
  id: string;
  type: NavigationItemsType;
}

export interface UnPinNavigationBody {
  id: string;
  type: NavigationItemsType;
}

export interface Error {
  message?: string;
  response?: {
    data?: {
      errorMessage?: string;
    };
  };
}
